import React from 'react';
import { useTokens } from '../../../../deps/@bshgroup/component-themes';

export interface HighlightAreaProps {
  /**
   * The content of the highlight area.
   */
  children?: React.ReactNode;
}

/**
 * Highlight Area Component provides a highlighted background
 */
export function HighlightArea({
  children,
  ...props
}: HighlightAreaProps & Omit<Partial<React.HTMLAttributes<HTMLDivElement>>, keyof HighlightAreaProps>) {
  const tokens = useTokens();

  return (
    <div css={{ backgroundColor: tokens.colors['secondary-base-100'] }} {...props}>
      {children}
    </div>
  );
}
